<template>
  <div class="page-wrap">
    <div class="header-filter">
      <div class="filter-title">
        <span class="title-text">LT校验表</span>
      </div>
      <div class="select-wrap">
        <el-date-picker
          class="data-range"
          v-model="filterData.time"
          type="daterange"
          range-separator="→"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          style="width: 240px; margin-right: 24px"
          format="yyyy-MM-dd"
          value-format="yyyyMMdd"
          :clearable="false"
          :picker-options="pickerOptions"
        >
        </el-date-picker>
        <product-select
          class="select-item"
          :value.sync="filterData.afid"
          placeholder="产品"
          @change="changeAfid"
          :isDefault="true"
        >
        </product-select>
        <el-select
          v-model="filterData.dimension"
          filterable
          placeholder="全部维度"
          class="select-item"
        >
          <el-option label="全部维度" :value="1"></el-option>
          <el-option label="国家和地区" :value="2"></el-option>
          <el-option label="渠道" :value="3"></el-option>
          <el-option label="campaign" :value="4"></el-option>
        </el-select>
        <el-select
          class="multiple-select"
          v-model="filterData.media"
          placeholder="全部渠道"
          filterable
          multiple
          collapse-tags
        >
          <el-option
            v-for="item in mediaList"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
        <areaMultiSelect
          class="select-item"
          :value.sync="filterData.geo"
          :optionsList="countryList"
        >
        </areaMultiSelect>
        <el-button style="margin-left: auto" @click="resetData"
          >重 置</el-button
        >
        <el-button type="primary" @click="searchData">查 询</el-button>
      </div>
    </div>
    <div class="content-wrap">
      <div class="table-header">
        <el-button
          type="text"
          icon="el-icon-refresh-right"
          @click="searchData()"
          >刷新</el-button
        >
        <span class="center-line"></span>
        <el-button
          type="text"
          icon="el-icon-download"
          @click="downLoadFileToExcel"
          >下载</el-button
        >
      </div>
      <div class="table-wrap">
        <el-table
          id="rebateSetTable"
          v-loading="loading"
          :data="tableData"
          style="width: 100%"
          height="100%"
        >
          <el-table-column
            v-for="item of tableCols"
            :label="item.label"
            :key="item.prop"
            :prop="item.prop"
            :align="item.align"
            :fixed="item.fixed"
            :width="item.width"
          >
            <el-table-column
              v-for="cell of item.children"
              :prop="cell.prop"
              :label="cell.label"
              :key="cell.prop"
              :width="cell.width || 120"
              :sortable="cell.sortable"
            >
            </el-table-column>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import { getMedias, ltCheckList } from "@/api/lt-check.js";
import { getCountryListFetch } from "@/api/api";
import areaMultiSelect from "@/components/areaMultiSelect.vue";
import moment from "moment";
import { columns } from "./columns.js";
import XLSX from "xlsx";
import FileSaver from "file-saver";
export default {
  name: "MaterialCreate",
  components: {
    areaMultiSelect,
  },
  mounted() {
    this.initSelect();
    this.genCols();
  },
  data() {
    return {
      filterData: {
        afid: null,
        dimension: 1,
        media: [],
        geo: [],
        time: [
          moment().subtract(39, "days").format("YYYYMMDD"),
          moment().subtract(32, "days").format("YYYYMMDD"),
        ],
      },
      pageData: {
        total: 0,
        size: 10,
        page: 1,
      },
      tableCols: [],
      allProductList: [],
      mediaList: [],
      countryList: [],
      loading: false,
      tableData: [],
      pickerOptions: {
        disabledDate: (time) => {
          return time.getTime() > Date.now() - 86400000 * 32;
        },
      },
    };
  },
  methods: {
    initSelect() {
      const timer = setInterval(() => {
        if (this.filterData.afid) {
          clearInterval(timer);
          this.changeAfid();
        }
      }, 200);
      //渠道
      getMedias().then((res) => {
        if (res.code === "0000") {
          this.mediaList = res.mediaList;
        }
      });
    },
    changeAfid() {
      //地区
      this.filterData.geo = [];
      getCountryListFetch({
        afid: this.filterData.afid,
      }).then((res) => {
        if (res.code === "0000") {
          this.countryList = res.countryList;
        }
      });
    },
    genCols() {
      let cols = JSON.parse(JSON.stringify(columns));
      switch (this.filterData.dimension) {
        case 1:
          cols[0].children = [
            {
              label: "全部(日期)",
              prop: "installDay",
            },
          ];
          break;
        case 2:
          cols[0].children = [
            {
              label: "地区",
              prop: "geo",
            },
          ];
          break;
        case 3:
          cols[0].children = [
            {
              label: "渠道",
              prop: "mediaSource",
            },
          ];
          break;
        case 4:
          cols[0].children = [
            {
              label: "渠道",
              prop: "mediaSource",
            },
            {
              label: "campaign",
              prop: "campaign",
            },
          ];
          break;
        default:
          break;
      }
      this.tableCols = cols;
    },
    searchData(resetPage) {
      if (resetPage) {
        this.pageData.page = 1;
      }
      let parmas = {
        // pageNumber: this.pageData.page,
        // pageSize: this.pageData.size,
        dateStart: this.filterData.time[0],
        dateEnd: this.filterData.time[1],
      };
      for (let [key, value] of Object.entries(this.filterData)) {
        if (key !== "time") {
          if (Array.isArray(value)) {
            if (value.length > 0) {
              parmas[key] = value.join();
            }
          } else if (value !== -1) {
            parmas[key] = value;
          }
        }
      }
      this.loading = true;
      ltCheckList(JSON.stringify(parmas)).then((res) => {
        this.loading = false;
        if (res.code === "0000") {
          this.genCols();
          this.tableData = res.predictionDatas;
        }
      });
    },
    resetData() {
      this.filterData.dimension = 1;
      this.filterData.media = [];
      this.filterData.geo = [];
      this.filterData.time = [
        moment().subtract(39, "days").format("YYYYMMDD"),
        moment().subtract(32, "days").format("YYYYMMDD"),
      ];
      this.changePage(1);
    },
    downLoadFileToExcel() {
      let fix = document.querySelector(".el-table__fixed");
      var xlsxParam = { raw: true }; //导出的内容只做解析，不进行格式转换(添加此行代码表格中的百分比就不会再导出的时候被转换成小数点)
      let wb;
      if (fix) {
        //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
        wb = XLSX.utils.table_to_book(
          document.querySelector("#rebateSetTable").removeChild(fix),
          xlsxParam
        );
        document.querySelector("#rebateSetTable").appendChild(fix);
      } else {
        wb = XLSX.utils.table_to_book(
          document.querySelector("#rebateSetTable"),
          xlsxParam
        );
      }
      let wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          "LT校验表.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    changePage(page) {
      this.pageData.page = page;
      this.searchData();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.searchData(true);
    },
  },
};
</script>

<style lang="less" scoped>
.page-wrap {
  padding: 16px 16px 0px 16px;
  box-sizing: border-box;
  height: calc(100vh - 50px);
  overflow: auto;
  .header-filter {
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px 0px 24px;
    // position: -webkit-sticky;
    // position: sticky;
    // top: -16px;
    // z-index: 1;
    .filter-title {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .title-text {
        color: rgba(0, 0, 0, 0.85);
        font-weight: bold;
        font-size: 15px;
      }
    }
    .select-wrap {
      display: flex;
      margin-top: 16px;
      .select-item {
        width: 200px;
        margin: 0px 24px 16px 0px;
      }
      .data-range {
        position: relative;
        margin-bottom: 16px;
        /deep/.el-range__icon {
          position: absolute;
          right: 6px;
          top: 0px;
        }
        /deep/.el-range-separator {
          line-height: 24px;
          color: rgba(0, 0, 0, 0.25);
        }
      }
      .multiple-select {
        height: 32px;
        margin-right: 24px;
        /deep/ .el-tag.el-tag--info:first-child {
          max-width: 120px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }
  }
  .content-wrap {
    margin-top: 16px;
    border-radius: 4px;
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    height: calc(100vh - 200px);
    background-color: #fff;
    display: flex;
    flex-direction: column;
    .table-header {
      text-align: right;
      padding: 4px 24px;
      flex-shrink: none;
      .center-line {
        height: 10px;
        border-right: 1px solid rgba(228, 228, 228, 1);
        margin: 0 16px;
      }
    }
    .table-wrap {
      padding: 0 24px 16px 24px;
      flex: 1;
    }
    .pagination-wrap {
      padding-right: 8px;
    }
  }
  .footer-page {
    padding: 0px 0px 10px 0px;
  }
}
</style>
